import type { BoggleGameModeDefinition } from '~/boggle/gameModes/types'
import { BOGGLE_CHALLENGE_ALLOWED_BONUS_IDS } from '~/boggle/gameModes/challengeAllowedBonuses'
import { RACE_CORE_PRESET, RACE_HARD_CORE_PRESET } from './preset'
import { RACE_CHALLENGE_CORE_DEFINITIONS } from './cores'
import { RaceHowToPlay } from './howToPlay'

export const RACE_GAME_MODE: BoggleGameModeDefinition = {
  challenge: {
    allowedBonusIds: BOGGLE_CHALLENGE_ALLOWED_BONUS_IDS,
    buttonLabel: 'Challenge',
    coreDefinitions: RACE_CHALLENGE_CORE_DEFINITIONS,
    practiceOverrides: {
      intervalCount: 1,
      intervalTimeSeconds: 30,
    },
  },
  color: '#54aca7',
  corePreset: RACE_CORE_PRESET,
  howToPlay: <RaceHowToPlay />,
  id: 'race',
  name: 'Race',
  tagline: 'Form as many words as you can.',
}

export const RACE_HARD_GAME_MODE: BoggleGameModeDefinition = {
  ...RACE_GAME_MODE,
  color: '#df5e4e',
  corePreset: RACE_HARD_CORE_PRESET,
  id: 'race-hard',
  name: 'Hard Race',
}
